import { render, staticRenderFns } from "./CommercialConditions.vue?vue&type=template&id=18f90358&lang=pug"
import script from "./CommercialConditions.vue?vue&type=script&lang=ts"
export * from "./CommercialConditions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports